import {MdOutlineLocationOn, MdOutlineEmail} from "react-icons/md";
import {BiPhoneCall} from "react-icons/bi";

export const contactInfo = [
  {
    Icon: BiPhoneCall,
    title: "Medicamental|SP",
    text: "0800-505 4900",
  },
  {
    Icon: BiPhoneCall,
    title: "Medicamental|RJ",
    text: "0800-505 4900",
  },
  {
    Icon: BiPhoneCall,
    title: "Soma|RJ",
    text: "(21)20424397",
  },
  {
    Icon: BiPhoneCall,
    title: "Patos de Minas - MG",
    text: "0800-340 7577",
  },
  {
    Icon: BiPhoneCall,
    title: "ALC | GOIÂNIA-GO",
    text: "(62) 3996-2833",
  },
  {
    Icon: BiPhoneCall,
    title: "Trimed | Anápolis - GO",
    text: "(62) 3315-4677",
  },
  {
    Icon: BiPhoneCall,
    title: "Medicamental | DF/ GO",
    text: "0800-505 49000",
  },
  {
    Icon: BiPhoneCall,
    title: "Vila Velha - ES",
    text: "0800-283 9655",
  },
  {
    Icon: BiPhoneCall,
    title: "Potiguar | Natal - RN",
    text: "8499691-5504",
  },
];
